/* -disable react/forbid-prop-types */
/* -disable react/default-props-match-prop-types */
import React, { Component } from 'react';

// Components
import THead from './THead';
import TBody from './TBody';
import EmptyState from '../../../../../components/EmptyState';
import LoadingIndicator from '../../../../../components/LoadingIndicator';
import AlertMessage from '../../../../../components/AlertMessage';

import './styles.css';

class NewTable extends Component {
  render() {
    const {
      headers,
      dataOrder,
      onOrderColumn,
      wrapCells = false,
      hasHover,
      className,
      activeRow,
      isActive,
      data,
    } = this.props;
    
    return (
      <div className={className}>
        {this.props.error && !this.props.isFetching && (
          <div className={`Table Table--${this.props.size || 'small'}`}>
            <AlertMessage
              actionText="Tentar novamente"
              message={this.props.error}
              onRetry={this.props.onRetry}
              className="Table__error-message"
              error
            />
          </div>
        )}
        {this.props.isFetching && (
          <div className={`Table Table--${this.props.size || 'small'}`}>
            <LoadingIndicator
              theme="dark"
              text="Carregando"
              className="Table__loading-indicator"
            />
          </div>
        )}
        {this.props.data.length > 0 && !this.props.isFetching && (
          <table className={`Table Table--${this.props.size || 'small'}`}>
            <THead
              dataOrder={dataOrder}
              headers={headers}
              onOrderColumn={onOrderColumn}
            />

            <TBody
              onRowClick={this.props.onRowClick}
              rows={data}
              headers={headers}
              wrapCells={wrapCells}
              hasHover={hasHover}
              activeRow={activeRow}
              isActive={isActive}
            />
          </table>
        )}
        {this.props.data.length === 0 &&
          !this.props.isFetching &&
          !this.props.error && (
            <EmptyState
              className="Table__empty-state"
              message="Não existem dados para exibição."
            />
          )}
      </div>
    );
  }
}

export default NewTable;
